import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="M6.025 8.333c-.802 0-1.458.657-1.458 1.459s.656 1.458 1.458 1.458c.802 0 1.459-.656 1.459-1.458 0-.802-.657-1.459-1.459-1.459Zm8.75 0c-.802 0-1.458.657-1.458 1.459s.656 1.458 1.458 1.458c.803 0 1.459-.656 1.459-1.458 0-.802-.657-1.459-1.459-1.459ZM8.942 9.792c0-.802.656-1.459 1.458-1.459.803 0 1.459.657 1.459 1.459s-.656 1.458-1.459 1.458a1.463 1.463 0 0 1-1.458-1.458Z" fill="currentColor" />' }
  })
);